import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { faChevronDown, faChevronUp, faLocation } from '@fortawesome/pro-light-svg-icons'
import { Button } from '@nazka/nazka.mapframe.components'

import { setHoveredItem } from '@App/pages/MosquitoObservations/mosquito-observations.slice'

// import { setZoomTarget } from '../../../MaptilerMap/maptiler-map.slice'

import './mosquito-observations-detection-list-item.styl'

function formatDate(value) {
  const date = value ? new Date(value) : null

  return date && !Number.isNaN(date.getTime())
    ? date
        .toLocaleString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        })
        .replace(',', '')
    : '-'
}

function formatCoordinates(coordinates) {
  if (!Array.isArray(coordinates)) return '-'

  const validCoordinates = coordinates.filter(coordinate => Number.isFinite(Number(coordinate)))

  return validCoordinates.length > 0
    ? validCoordinates.map(coordinate => Number(coordinate).toFixed(6)).join(', ')
    : '-'
}

function MosquitoObservationsDetectionListItem({ map, trap, mosquitoSpecies }) {
  const dispatch = useDispatch()
  const [isExpanded, setIsExpanded] = useState(false)
  const properties = trap?.properties || {}
  const status = trap?.status || properties.status || 'inactive'
  const {
    client_name: clientName,
    latestRecordTime,
    name,
  } = properties
  const { coordinates } = trap?.geometry || {}
  const itemId = trap?.trapId || properties.locationKey || clientName
  const displayName = name || clientName || 'Unclassified'
  const lastActivity = latestRecordTime

  const hoveredItem = useSelector(state => state.mosquitoDetection.hoveredItem)
  const hoveredClusterTrapIds = useSelector(state => state.mosquitoDetection.hoveredClusterTrapIds)
  const hoveredItemId = hoveredItem?.trapId || hoveredItem?.properties?.locationKey || hoveredItem?.properties?.client_name
  const isHovered = (hoveredItem && hoveredItemId === itemId)
    || hoveredClusterTrapIds.includes(itemId)
  const stats = Array.isArray(trap?.stats)
    ? trap.stats
    : Array.isArray(trap?.data?.stats) ? trap.data.stats : []
  const totalCollectedSamples = stats.reduce((sum, sample) => sum + (sample.count || 0), 0)

  return (
    <div
      className={`mosquito-observations-detection-list-item${isHovered ? ' mosquito-observations-detection-list-item--hovered' : ''}`}
      onMouseEnter={() => dispatch(setHoveredItem(trap))}
      onMouseLeave={() => dispatch(setHoveredItem(null))}
      id={itemId ? (`trap-${itemId}`).toLowerCase() : undefined}
    >
      <div className="mosquito-observations-detection-list-item__head">
        <div className="mosquito-observations-detection-list-item__head--type">
          <span className={`color-indicator-octagon color-indicator-octagon--${status}`}></span>
          <div className="mosquito-observations-detection-list-item__head--type__text">
            <span className="mosquito-observations-detection-list-item__head--type__text__name">
              {displayName}
            </span>
            <span className="mosquito-observations-detection-list-item__head--type__text__species">
              {status}
            </span>
          </div>
        </div>
        <div className="mosquito-observations-detection-list-item__head__actions">
          <Button
            className="mosquito-observations-detection-list-item__head__actions__action"
            icon={faLocation}
            layout="ghost"
            hover={false}
            onClick={() => {
              const coordinates = trap?.geometry?.coordinates
              if (!map || !Array.isArray(coordinates) || coordinates.length < 2) return

              map.flyTo({
                center: coordinates,
                zoom: 14,
                essential: true,
              })
            }}
          />
          <Button
            className="mosquito-observations-detection-list-item__head__actions__action"
            icon={isExpanded ? faChevronUp : faChevronDown}
            layout="ghost"
            hover={false}
            onClick={() => setIsExpanded(!isExpanded)}
          />
        </div>
      </div>
      <div className={`mosquito-observations-detection-list-item__content${isExpanded ? ' mosquito-observations-detection-list-item__content--expanded' : ''}`}>
        <div className="mosquito-observations-detection-list-item__content__inner">
          <div className="mosquito-observations-detection-list-item__content--devicename">
            <p>Source</p>
            <p>{properties.source || '-'}</p>
          </div>
          <hr />
          <div className="mosquito-observations-detection-list-item__content--devicename">
            <p>Device name</p>
            <p>{displayName}</p>
          </div>
          <hr />
          <div className="mosquito-observations-detection-list-item__content--location">
            <p>Location</p>
            <p>{formatCoordinates(coordinates)}</p>
          </div>
          <hr />
          <div className="mosquito-observations-detection-list-item__content--lastactivity">
            <p>Latest catch</p>
            <p>{formatDate(lastActivity)}</p>
          </div>
          <hr />
          <div className="mosquito-observations-detection-list-item__content__collectedsamples">
            <p>Collected samples</p>
            <p>{totalCollectedSamples}</p>
          </div>
          <div className="mosquito-observations-detection-list-item__content__collectedsamples-list">
            {stats.map(({ classification, count, sex }) => {
              const speciesInfo = mosquitoSpecies.find(species => species.label.toLowerCase() === classification.toLowerCase())

              return (
                <div key={classification} className="mosquito-observations-detection-list-item__content__collectedsamples-list__item">
                  <div className="mosquito-observations-detection-list-item__content__collectedsamples-list__item__type">
                    <div className="mosquito-observations-detection-list-item__content__collectedsamples-list__item__type--name">
                      <span className="color-indicator" style={{ backgroundColor: speciesInfo?.color || '#9ca3af' }}></span>
                      <span>{classification}</span>
                    </div>
                    <span>{count}</span>
                  </div>
                  <div className="mosquito-observations-detection-list-item__content__collectedsamples-list__item__sexes">
                    <p>
                      {'Female: '}
                      {sex?.female || 0}
                    </p>
                    <span> | </span>
                    <p>
                      {'Male: '}
                      {sex?.male || 0}
                    </p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MosquitoObservationsDetectionListItem
